import * as React from 'react';

import IconCollectionsFilled from './IconCollectionsFilled';

export const collectionsFilled = () => <IconCollectionsFilled />;

export default {
    title: 'Icons/Collections/Filled',
    component: IconCollectionsFilled,
    parameters: {
        notes: "`import IconCollectionsFilled from 'box-ui-elements/es/icons/collection/IconCollectionsFilled';`",
    },
};
